// src/components/RecruiterMap.tsx
import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

export default function RecruiterMap() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    const map = new maplibregl.Map({
      container: ref.current,
      style: 'https://demotiles.maplibre.org/style.json', // remplace plus tard par ton style/clé
      center: [2.4, 46.8], zoom: 5
    });

    map.on('load', async () => {
      const data = await fetch('/api/recruteurs/points').then(r => r.json());
      map.addSource('recruteurs', { type: 'geojson', data });

      // Heatmap "halo" global
      map.addLayer({
        id: 'heat',
        type: 'heatmap',
        source: 'recruteurs',
        paint: {
          'heatmap-weight': ['interpolate', ['linear'], ['get', 'count'], 1, 0.2, 50, 1],
          'heatmap-intensity': 1.1,
          'heatmap-radius': 40,
          'heatmap-opacity': 0.7
        }
      });

      // Glow par point (faisceau)
      map.addLayer({
        id: 'glow',
        type: 'circle',
        source: 'recruteurs',
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['get', 'count'], 1, 6, 50, 24],
          'circle-color': 'rgba(255,255,255,0.85)',
          'circle-blur': 0.6
        }
      });
    });

    return () => map.remove();
  }, []);

  return <div ref={ref} style={{ height: 500, borderRadius: 16, overflow: 'hidden' }} />;
}
